import { fetchApi, rpcApi } from '@/app/api';

export function fetchCacheEntries() {
  return fetchApi('/cache_entries', { order: 'last_hit.desc' });
}

export function fetchCacheStats() {
  return fetchApi('/cache_stats', { order: 'resource.asc' });
}

export async function fetchCacheEnabled(): Promise<boolean> {
  const rows = await fetchApi('/cache_settings', { key: 'eq.enabled' });
  return rows[0]?.value !== false;
}

export function setCacheEnabled(enabled: boolean) {
  return rpcApi('cache_set_enabled', { p_enabled: enabled });
}

export function clearCache() {
  return rpcApi('cache_clear', {});
}

export function resetCacheStats() {
  return rpcApi('cache_reset_stats', {});
}
